export const FLOWMAP_CONFIG = {
    MAP_CHECK_INTERVAL: 100,
    ARROW_ANGLE: 30,
    VOLUME_SCALE_FACTOR: 9999,
    BASE_VOLUME_OFFSET: 1,
    // Line thickness configuration
    LINE_WIDTH: {
        MIN: 1, // Thinner minimum line width
        MAX: 5, // Thicker maximum line width
    },
    ARROW_WIDTH: {
        MIN: 2, // Thinner minimum arrow width
        MAX: 8, // Thicker maximum arrow width
    },
    // Arrow zoom scaling configuration
    ARROW_ZOOM: {
        BASE_ZOOM: 4, // Reference zoom level for arrow sizing
        ZOOM_FACTOR: 1.8, // How much arrows scale per zoom level (more aggressive)
        MIN_LENGTH: 0.001, // Minimum arrow length at high zoom (much smaller)
        MAX_LENGTH: 1.0, // Maximum arrow length at low zoom
        BASE_LENGTH: 0.125, // Base arrow length before scaling (slightly larger)
        VOLUME_SCALE: 0.04, // How much volume affects arrow size (reduced)
        VOLUME_MAX: 5000, // Maximum volume for scaling
    },
    // Scaling algorithm configuration
    SCALING: {
        // What percentile to cap outliers at
        OUTLIER_PERCENTILE: 90,
        // Minimum value threshold - values below this get minimum thickness
        MIN_THRESHOLD: 1,
        // How much to compress the top end
        COMPRESSION_FACTOR: 0.3,
    },
};

export const FILTER_TYPES = {
    FROM_COUNTRIES: 'fromCountries',
    TO_COUNTRIES: 'toCountries',
    SOURCES: 'sources',
    TYPES: 'types',
    HS_CODES: 'hsCodes',
    UNITS: 'units',
    YEAR: 'year',
};

export const DATA_PROPERTIES = {
    START_COUNTRY_ISO: 'startCountryIso',
    END_COUNTRY_ISO: 'endCountryIso',
    DATA_SOURCE: 'dataSource',
    DATA_TYPE: 'dataType',
    HS_CODE: 'hsCode',
    UNIT: 'unit',
    YEAR: 'year',
};
